import { put, all, retry } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import { authClient } from '../api/Client';
import * as types from '../constants';
import { NOTIFICATION } from '../constants';
import { errorNotification } from '../../shared-components/Notifications';

export function* loadMostWidespreadTag() {
  try {
    const res = yield retry(4, 500, authClient?.Widget?.mostWidespreadTag);
    yield put({
      type: resolve(types?.LOAD_MOST_WIDESPREAD_TAG),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MOST_WIDESPREAD_TAG),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MOST_WIDESPREAD_TAG),
        ),
      }),
    ]);
  }
}

export function* loadTopTrendingTags() {
  try {
    const res = yield retry(4, 500, authClient?.Widget?.topTrendingTags);
    yield put({
      type: resolve(types?.LOAD_TOP_TRENDING_TAGS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_TOP_TRENDING_TAGS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_TOP_TRENDING_TAGS),
        ),
      }),
    ]);
  }
}

export function* loadFPAvg() {
  try {
    const res = yield retry(4, 500, authClient?.Widget?.fpAvg);
    yield put({
      type: resolve(types?.LOAD_FP_AVG),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_FP_AVG),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_FP_AVG)),
      }),
    ]);
  }
}
